/* eslint-disable react/jsx-props-no-spreading */

import {
    MenuItem,
} from '@mui/material'
import PropTypes from 'prop-types'
import {
    useTheme,
} from '@mui/material/styles'

const propTypes = {
    innerRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            current: PropTypes.any, // eslint-disable-line
        }),
    ]),
    innerProps: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            current: PropTypes.elementType,
        }),
    ]),
    isFocused: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    children: PropTypes.string,
    selectProps: PropTypes.shape({
        showTitleOptions: PropTypes.bool,
    }).isRequired,
}

const defaultProps = {
    innerRef: {},
    innerProps: {},
    children: '',
}

function Option(props) {
    const {
        innerRef,
        innerProps,
        isFocused,
        isSelected,
        children,
        selectProps,
    } = props

    const {
        showTitleOptions,
    } = selectProps

    const theme = useTheme()

    return (
        <MenuItem
            title={(showTitleOptions && children) || ''}
            buttonRef={innerRef}
            selected={isFocused}
            component="div"
            style={{
                fontWeight: isSelected ? 600 : 400,
                textOverflow: 'ellipsis',
                display: 'block',
                overflow: 'hidden',
                color: theme.palette.secondary[900],
            }}
            {...innerProps}
        >
            {children}
        </MenuItem>
    )
}

Option.propTypes = propTypes
Option.defaultProps = defaultProps

export default Option
